import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { TreeService } from '../../../tree.service';
import { TreeItemTypeListItemDto, TreeItemTypeListResponseDto } from '../../../../../../api-main';
import { TreeFormData } from '../TreeFormData';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SkeletonComponent } from '../../../../../shared/components/skeleton/skeleton.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-tree-form-select-node-type',
  templateUrl: './tree-form-select-node-type.component.html',
  styleUrl: './tree-form-select-node-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, SkeletonComponent],
})
export class TreeFormSelectNodeTypeComponent implements OnInit {
  private treeService = inject(TreeService);
  private cdr = inject(ChangeDetectorRef);

  @Input({ required: true }) data: TreeFormData;

  loaded = false;

  nodeTypes: TreeItemTypeListItemDto[];

  private $unsubscribe = takeUntilDestroyed();

  ngOnInit() {
    // getItemTypes is cached (shareReplay); the edit flow resolves its type in the parent
    // this only loads the list to render when creating a new node.
    this.treeService
      .getItemTypes()
      .pipe(this.$unsubscribe)
      .subscribe((types: TreeItemTypeListResponseDto) => {
        this.nodeTypes = types.data;
        this.loaded = true;
        this.cdr.detectChanges();
      });
  }

  typeClicked(type: TreeItemTypeListItemDto) {
    this.data.typeSelected$.next(type);
    this.cdr.detectChanges();
  }
}
